/**
 * Directive: permit
 * @deprecated Use acmePermissions directive instead
 */
angular.module('acme.common.directive.permit', [
  'acme.common.service.permissions'
])
.directive('permit', [ 'PermissionsService', function(PermissionsService) {

    return {
      restrict: 'A',
      link: function($scope, $element, $attrs, $ctrl) {
        var test = $attrs.permit;

        // Modified after controller runs
        if (test.match(/^\[/)) {
          test = $scope.$eval(test);
        }

        if (!PermissionsService.check(test)) {
          $element.remove();
        }
      }
    };

}]);